import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import { Link as RouterLink } from 'react-router-dom'

import { CONCIERGE_TYPES } from '@/store/constant'
import { useConciergeList } from '@hooks/useConciergeList'
import { DW_LOTUS_LOGO_URL, DW_WW_LOGO_URL } from '@lib/config'
import { Typography, useMediaQuery } from '@mui/material'

export default function Logo() {
  const { conciergeType } = useConciergeList()
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'))
  const logoUrl =
    conciergeType === CONCIERGE_TYPES.BOOKING_LOVE
      ? DW_LOTUS_LOGO_URL
      : DW_WW_LOGO_URL
  return (
    <Link
      component={RouterLink}
      to='/'
      aria-label='theme-logo'
      sx={{
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
      }}
    >
      <Box
        component='img'
        src={logoUrl}
        sx={{
          position: 'relative',
          zIndex: 2,
          pl: (theme) => theme.spacing(1),
          height: (theme) => theme.spacing(6.75),
          display: 'block',
          mx: 'auto',
        }}
      />

      <Typography
        variant='h3'
        sx={{
          zIndex: 1,
          pl: 1,
          color: (theme) => theme.palette.text.dark,
          textAlign: 'center',
        }}
      >
        {isSmallScreen ? conciergeType : `${conciergeType} Dashboard`}
      </Typography>
    </Link>
  )
}
